module.exports = __webpack_public_path__ + "img/news.309e5f56.png";